"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfig = exports.ConfigContextProvider = exports.ConfigContext = exports.expandSettings = void 0;
const react_1 = __importStar(require("react"));
///
/// This converts a flat key-value pair env settings into a JS object with nested values (that are either other JS objects or arrays)
///
function expandSettings(o) {
    const settings = {};
    Object.keys(o)
        .sort()
        .forEach((key) => {
        const segments = key.split('__');
        if (segments.length === 1) {
            // no exted object or array - simple key setting
            let value = o[key];
            if (value === 'true') {
                value = true;
            }
            if (value === 'false') {
                value = false;
            }
            settings[key] = value;
            return;
        }
        let segmentValue = settings;
        segments.forEach((segment, segmentIndex) => {
            if (segmentIndex + 1 === segments.length) {
                // is last segment, if so set the value
                segmentValue[segment] = o[key];
            }
            else {
                const arrayIndex = parseInt(segment, 10);
                if (Number.isNaN(arrayIndex)) {
                    // this is an object
                    const valueObject = segmentValue;
                    if (valueObject[segment] === undefined) {
                        // check if the next segment is an array index or not and assign [] or {}
                        valueObject[segment] =
                            segmentIndex + 1 < segments.length && !Number.isNaN(parseInt(segments[segmentIndex + 1], 10)) ? [] : {}; // assign empty object
                    }
                    segmentValue = valueObject[segment];
                }
                else {
                    // this is an array
                    const valueArray = segmentValue;
                    while (arrayIndex >= valueArray.length) {
                        valueArray.push({}); // add more elements to be able to hold that index
                    }
                    segmentValue = valueArray[arrayIndex];
                }
            }
        });
    });
    return settings;
}
exports.expandSettings = expandSettings;
exports.ConfigContext = react_1.default.createContext(undefined);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ConfigContextProvider = ({ children, config, outerSettings }) => {
    const settings = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, expandSettings(config)), outerSettings)), [config, outerSettings]);
    return react_1.default.createElement(exports.ConfigContext.Provider, { value: settings }, children);
};
exports.ConfigContextProvider = ConfigContextProvider;
const useConfig = () => {
    const config = (0, react_1.useContext)(exports.ConfigContext);
    if (config === undefined) {
        throw new Error('useConfig must be used within a ConfigContextProvider');
    }
    return config;
};
exports.useConfig = useConfig;
